import {Injectable} from '@angular/core';
import {NotificationsApiService} from '@npck/af-frontend-api';
import {BehaviorSubject, filter, interval, mergeMap, Subscription, takeWhile} from 'rxjs';
import {AuthHolderService} from './auth-holder.service';

const NOTIFICATIONS_COUNT_UPDATE_INTERVAL = 360_000;

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {
    notificationsSubject = new BehaviorSubject<number>(0);

    private notificationsSubscription: Subscription;

    constructor(
        private authHolderService: AuthHolderService,
        private notificationsApiService: NotificationsApiService
    ) {
        this.authHolderService.isAuthorized
            .pipe(filter(isAuthorized => isAuthorized))
            .subscribe(() => this.forceLoadNotificationsCount());
        this.authHolderService.isAuthorized
            .pipe(filter(isAuthorized => !isAuthorized))
            .subscribe(() => this.notificationsSubscription?.unsubscribe());
    }

    decreaseUnreadCount(by: number): void {
        this.notificationsSubject.next(Math.max(0, this.notificationsSubject.value - by));
    }

    private forceLoadNotificationsCount(): void {
        this.notificationsSubscription?.unsubscribe();
        this.notificationsApiService.getNotificationsCount()
            .subscribe(response => {
                this.listenToNotificationsCount();
                this.notificationsSubject.next(response);
            });
    }

    private listenToNotificationsCount(): void {
        this.notificationsSubscription = interval(NOTIFICATIONS_COUNT_UPDATE_INTERVAL)
            .pipe(
                takeWhile(() => !this.notificationsSubscription?.closed && this.authHolderService.isAuthorized.value),
                mergeMap(() => this.notificationsApiService.getNotificationsCount()))
            .subscribe(response => this.notificationsSubject.next(response));
    }
}
